module.exports = "https://web-assets.ifttt.com/packs/media/service_icons/hue-2229b0c5.svg";